export interface DemoWatermarkMarker {
  id: string;
  offsetSeconds: number;
}

export const watermarkedDemoMarkers: DemoWatermarkMarker[] = [
  { id: 'wm-01', offsetSeconds: 2.179 },
  { id: 'wm-02', offsetSeconds: 4.278 },
  { id: 'wm-03', offsetSeconds: 6.649 },
  { id: 'wm-04', offsetSeconds: 9.458 },
  { id: 'wm-05', offsetSeconds: 12.319 },
  { id: 'wm-06', offsetSeconds: 15.139 },
  { id: 'wm-07', offsetSeconds: 18.719 },
  { id: 'wm-08', offsetSeconds: 21.979 },
  { id: 'wm-09', offsetSeconds: 24.149 },
  { id: 'wm-10', offsetSeconds: 26.578 },
  { id: 'wm-11', offsetSeconds: 28.508 },
  { id: 'wm-12', offsetSeconds: 30.538 },
  { id: 'wm-13', offsetSeconds: 32.598 },
  { id: 'wm-14', offsetSeconds: 36.21 },
  { id: 'wm-15', offsetSeconds: 38.138 },
  { id: 'wm-16', offsetSeconds: 40.07 }
];
